module.exports = __webpack_public_path__ + "static/media/infoDotsBlack.ce323bf6.svg";